<template>
  <div id="content" class="app-content">
    <!-- page header -->
    <b-row>
      <b-col>
        <h1 class="page-header">Suppliers <small>all listings.</small></h1>
      </b-col>

      <b-col sm="auto" class="ml-auto">
        <b-button variant="default" :to="{ name: 'suppliers.new' }" :disabled="$cannot('supplier.manage')">
          New Supplier
        </b-button>
      </b-col>
    </b-row>

    <!-- search -->
    <display-results :index-name="suppliersIndex" v-slot:default="{ items }">
      <b-table
        :fields="fields"
        :items="mapItems(items)"
        show-empty
        stacked="sm"
        bordered
        hover
        @row-clicked="row => showDetails(row)"
      >

        <template v-slot:cell(options)="row">
          <b-dropdown variant="default" size="sm" text="Options" offset="25" right>
            <b-dropdown-item
              :to="{ name: 'suppliers.edit', params: { id: row.item.id } }"
              :disabled="$cannot('supplier.manage')"
            >
              Edit
            </b-dropdown-item>

            <b-dropdown-item
              :to="{ name: 'suppliers.bookings', params: { id: row.item.id } }"
              :disabled="$cannot('supplier.booking')"
            >
              Bookings
            </b-dropdown-item>

            <b-dropdown-item
              :to="{ name: 'suppliers.users', params: { id: row.item.id } }"
              :disabled="$cannot('supplier.booking')"
            >
              Users
            </b-dropdown-item>

            <b-dropdown-item
              size="sm"
              :to="{ name: 'supplier.gallery', params: { id: row.item.id } }"
              :disabled="$cannot('supplier.manage')"
            >
              Images &amp; Content
            </b-dropdown-item>
          </b-dropdown>
        </template>

        <template v-slot:row-details="{ item }">
          <b-overlay :show="loading === item.id">
            <supplier-details :supplier="item" @loaded="loading = 0" />
          </b-overlay>
        </template>
      </b-table>
    </display-results>
  </div>
</template>

<script>
import DisplayResults from '../components/DisplayResults.vue'
import SupplierDetails from './SupplierDetails.vue'

export default {
  name: 'SuppliersPage',
  inject: ['$cannot'],
  components: { DisplayResults, SupplierDetails },
  data() {
    return { suppliersIndex: process.env.VUE_APP_ALGOLIA_SUPPLIERS_INDEX, loading: 0, current: 0 }
  },
  computed: {
    fields() {
      return [
        { key: 'id', label: 'ID', sortable: false },
        { key: 'booking_name', sortable: false, label: 'Name' },
        { key: 'booking_phone', sortable: false, label: 'Phone' },
        { key: 'booking_phone_time', sortable: false, label: 'Phone Time' },
        { key: 'booking_city', sortable: false, label: 'City' },
        { key: 'contact_name', sortable: false },
        { key: 'country_code', sortable: false },
        { key: 'options', label: '' },
      ]
    },
  },
  methods: {
    mapItems(items) {
      return items.map(item => ({ ...item, _showDetails: this.current === item.id }))
    },
    showDetails(supplier) {
      this.loading = supplier.id
      this.current = supplier.id === this.current ? 0 : supplier.id
    },
  },
}
</script>
